import { Component } from '@angular/core';

@Component({
  selector: 'nida-web-change-password-page',
  templateUrl: './change-password-page.component.html',
  styleUrls: ['./change-password-page.component.scss'],
  standalone: false,
})
export class ChangePasswordPageComponent {}
